import { useParams, Logo, ToastContainer, BsFillPersonLinesFill, FaBuilding, FaMobileAlt, FaMapMarkerAlt, MdErrorOutline, FaEtsy, FaLink, MdEmail, AiOutlineLoading3Quarters, overlayStyle, loaderStyle, Select, TbNumbers, BiCheck } from '../../common/common'
import { useErrorContext } from '../../context/ErrorContext';
import MidPersonalDetails from '../../middleware/Seller/Details/MidPersonalDetails';
import styles from "../Startup/Choose.module.css";
// import { useSelector, useDispatch } from 'react-redux';
import { Capitalize } from '../../common/CommonFunctions'

const PersonalDetails = () => {

  const { type } = useParams();
  const { users, values, isLoading, handleSubmit, mobilevalue, emailvalue, handleChange, handleFileChange,
    countryData, getCities, getStates, selectedCity, selectedCountry, selectedState, handleGetState, handleGetCities, stateData, cityData, handleSetCityId, isIndian
  } = MidPersonalDetails(type);


  const { error } = useErrorContext();


  return (
    <div className="flex flex-row">
      {isLoading && (
        <div style={overlayStyle}>
          <div style={loaderStyle}>Loading...</div>
        </div>
      )}
      <div className={`${styles.personalDetails} ` + " hidden  lg:block lg:w-[30%]  fixed h-screen overflow-y-auto scrollbar-hide "} >
        <div className="h-[100px]">
          <div className="flex flex-row justify-center">
            <img className="mr-0" src={Logo} width={160} height={70} alt="Dasahboard" />
          </div>
        </div>
        <div className="mt-32">
          <div className='relative mx-10  rounded-xl bg-[#006e65]'>
            <div className="block">
              <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                {/* BiCheck Icon Container */}
                <div className={`${styles.animationPulse} bg-[#ffc107] text-[#1a0048] rounded-full flex justify-center items-center text-xl w-10 h-10 sm:w-12 sm:h-12`}>

                  <span className="text-xl sm:text-2xl px-2">
                    1
                  </span>
                </div>
                {/* Text Content */}
                <div className="px-3 sm:ml-5 w-full sm:w-auto">
                  <h1 className="text-xl font-semibold text-white">
                    {Capitalize(type)} Profile Configuration
                  </h1>
                  <p className="text-sm font-medium text-white">
                    To establish your seller profile, please complete the designated form. You may create multiple seller profiles under the same Selzor account; however, a separate plan is required for each seller profile.
                  </p>
                </div>
              </div>
            </div>
            {(type === 'seller' || type === 'Seller') && <div className="block">
              <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                {/* BiCheck Icon Container */}
                <div className=" bg-[#686868] text-[#a0a0a0] rounded-full flex justify-center items-center text-xl w-10 h-10 p-1 px-3 sm:w-12 sm:h-12 opacity-20">

                  <span className="text-xl sm:text-2xl px-2">
                    2
                  </span>
                </div>

                {/* Text Content */}
                <div className="px-3 sm:ml-5 w-full sm:w-auto opacity-20">
                  <h1 className="text-xl font-semibold text-[#a0a0a0]">
                    {" "} Product Attributes {" "}
                  </h1>
                  <p className="text-sm font-medium text-[#a0a0a0]">
                    {" "}Select mandatory attributes (code, name, category) and choose which to display to customers while adding product data{" "}
                  </p>
                </div>
              </div>
            </div>}
            {(type === 'seller' || type === 'Seller') && <div className="block">
              <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                {/* BiCheck Icon Container */}
                <div className=" bg-[#686868] text-[#a0a0a0] rounded-full flex justify-center items-center text-xl w-10 h-10 p-1 px-3 sm:w-12 sm:h-12 opacity-20">

                  <span className="text-xl sm:text-2xl px-2">
                    3
                  </span>
                </div>

                {/* Text Content */}
                <div className="px-3 sm:ml-5 w-full sm:w-auto opacity-20">
                  <h1 className="text-xl font-semibold text-[#a0a0a0]">
                    {" "} Reorder Attributes {" "}
                  </h1>
                  <p className="text-sm font-medium text-[#a0a0a0]">
                    {" "}Streamline product attributes to enhance clarity and facilitate informed decision-making{" "}
                  </p>
                </div>
              </div>
            </div>}
            {(type === 'seller' || type === 'Seller') && <div className="block">
              <div className="flex flex-col sm:flex-row mx-3 py-3 items-start">
                {/* BiCheck Icon Container */}
                <div className=" bg-[#686868] text-[#a0a0a0] rounded-full flex justify-center items-center text-xl w-10 h-10 p-1 px-3 sm:w-12 sm:h-12 opacity-20">

                  <span className="text-xl sm:text-2xl px-2">
                    4
                  </span>
                </div>

                {/* Text Content */}
                <div className="px-3 sm:ml-5 w-full sm:w-auto opacity-20">
                  <h1 className="text-xl font-semibold text-[#a0a0a0]">
                    {" "}Import Product Excelsheet{" "}
                  </h1>
                  <p className="text-sm font-medium text-[#a0a0a0]">
                    {" "}Easily import product information using the Excel spreadsheet to manage your inventory better{" "}
                  </p>
                </div>
              </div>
            </div>}
          </div>
        </div>
      </div>
      <div className=" grid grid-cols-1 lg:col-span-8 lg:ml-[30%] w-full">
        <div className="text-center text-blue-700 lg:hidden">
          <div className="max-w-full w-full my-2 mx-auto p-2 flex justify-center">
            <img src={Logo} width={160} height={70} alt="Logo" />
          </div>
        </div>
        <div className="max-w-full bg-white pb-10 mb-24 px-5 ">
          <div className=" p-3 rounded-xl my-2 bg-[#ddfdfa]">
            <h1 className=" text-lg text-[#0cb1a3] font-bold">   {Capitalize(type)}  Profile Configuration</h1>
            <p className=" text-[#414747] text-md font-medium">To establish your seller profile, please complete the designated form. You may create multiple seller profiles under the same Selzor account; however, a separate plan is required for each seller profile.</p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="p-3 border-[1px] border-solid border-[#dcdcdc] rounded-xl lg:p-12">
              <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-0 m-auto">
                <div className="mr-5">
                  <label className="text-sm text-[#02264a] font-semibold"> Primary Contact <span className="text-red-700 "> * </span>{" "}</label>
                  <div className="bg-transparent border-[1px] border-[#dcdcdc] my-3  relative  p-2 w-full  rounded-md mt-1  active:bg-transparent">
                    <BsFillPersonLinesFill className="h-4 w-4 absolute left-3 top-3 text-[#02264a]" />
                    <input className="text-[#767676] select-none cursor-not-allowed bg-transparent ml-6 pl-5 focus:outline-none  pr-5 w-[90%]" type="text" name="primaryContact" id="primaryContact" autoComplete="new-password"
                      value={values.primaryContact}
                      readOnly
                      required={true}
                    />
                  </div>
                </div>
                <div className="mr-5">
                  <label className="text-sm text-[#02264a] font-semibold"> Email Address <span className="text-red-700 "> * </span>{" "}</label>
                  <div className=" bg-transparent border-[#dcdcdc]  relative  p-2 w-full  rounded-md mt-1 border-[1px] active:bg-transparent">
                    <MdEmail className="h-4 w-4 absolute left-3 top-3 text-[#02264a]" />
                    <input
                      className="text-[#767676] select-none cursor-not-allowed bg-transparent ml-6 pl-5 focus:outline-none  pr-5 w-[90%]"
                      type="text"
                      name="emailnmobi"
                      id="emailnmobi"
                      autoComplete="new-password"
                      value={values.emailnmobi}
                      readOnly
                      required={true}
                    />
                     {error.emailnmobi && (
                      <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                    )}
                  </div>
                  {error.emailnmobi && (
                    <p className="my-2 px-2 text-red-600 text-xs">
                      {error.emailnmobi}
                    </p>
                  )}
                </div>
                <div className="mr-5">
                  <label className="text-sm text-[#02264a] font-semibold">
                    Company Name <span className="text-red-700 "> * </span>{" "}
                  </label>
                  <div
                    className={`${error.companyName
                      ? "bg-red-100 border-red-700 mb-0"
                      : " bg-transparent border-[1px] border-[#dcdcdc] my-3"
                      }  relative p-2 w-full rounded-md mt-1  active:bg-transparent `}
                  >
                    <FaBuilding className="h-4 w-4 absolute left-3 top-3 text-[#02264a]" />
                    <input
                      className="bg-transparent ml-6 pl-5 focus:outline-none  pr-5 w-[90%] placeholder-[#767676] text-[#02264a]"
                      type="text"
                      name="companyName"
                      id="companyName"
                      autoComplete="new-password"
                      value={values.companyName}
                      onChange={handleChange}
                      onKeyUp={handleChange}
                      placeholder="Enter Company Name"
                    />
                    {error.companyName && (
                      <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                    )}
                  </div>
                  {error.companyName && (
                    <p className="my-2 px-2 text-red-600 text-xs">
                      {error.companyName}
                    </p>
                  )}
                </div>
                <div className="mr-5">
                  <label className="text-sm text-[#02264a] font-semibold">
                    Company Initials <span className="text-red-700 "> * </span>{" "}
                    <span className="text-sm">( 3 to 6 Chracter only)</span>{" "}
                  </label>
                  <div
                    className={`${error.companyInitials
                      ? "bg-red-100  mb-0"
                      : " bg-transparent border-[1px] border-[#dcdcdc] mb-1"
                      } relative  p-2 w-full  rounded-md mt-1 border-[1px]   active:bg-transparent `}
                  >
                    <FaEtsy className="h-4 w-4 absolute left-3 top-3 text-[#02264a]" />
                    {/* <input
                      className="bg-transparent ml-6 pl-5 focus:outline-none  pr-5 w-[90%] placeholder-[#767676] text-[#02264a]"
                      type="text"
                      name="companyInitials"
                      id="companyInitials"
                      autoComplete="new-password"
                      value={values.companyInitials}
                      onChange={handleChange}
                      onKeyUp={handleChange}
                      placeholder="Enter Company Initials"
                    /> */}
                    <input
                      className="bg-transparent ml-6 pl-5 focus:outline-none pr-5 w-[90%] placeholder-[#767676] text-[#02264a]"
                      type="text"
                      name="companyInitials"
                      id="companyInitials"
                      autoComplete="new-password"
                      value={values.companyInitials.toUpperCase().replace(/\s/g, '').slice(0, 6)}
                      onChange={(e) => {
                        const raw = e.target.value;
                        const cleaned = raw.toUpperCase().replace(/\s/g, '').slice(0, 6);
                        handleChange({
                          target: {
                            name: "companyInitials",
                            value: cleaned,
                          },
                        });
                      }}
                      placeholder="Enter Company Initials"
                    />



                    {error.companyInitials && (
                      <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                    )}
                  </div>
                  <div className="mb-3">
                    <span className="px-1 text-[#02264a]">
                      {" "}
                      eg. Initials for 'My business pvt ltd' can be 'MBPL'
                    </span>
                  </div>
                  {error.companyInitials && (
                    <p className="my-2 px-2 text-red-600 text-xs">
                      {error.companyInitials}
                    </p>
                  )}
                </div>
                <div className="mr-5">
                  <label className="text-sm text-[#02264a] font-semibold"> Office Contact Number </label>
                  <div className="bg-transparent border-[1px] border-[#dcdcdc] my-3 relative p-2 w-full rounded-md mt-1  active:bg-transparent">
                    <FaMobileAlt className="h-4 w-4 absolute left-3 top-3 text-[#02264a]" />
                    <input
                      className="bg-transparent ml-6 pl-5 focus:outline-none  pr-5 w-[90%] placeholder-[#767676] text-[#02264a]"
                      type="text"
                      name="contactnumber"
                      id="contactnumber"
                      autoComplete="new-password"
                      value={values.contactnumber}
                      onChange={handleChange}
                      placeholder="Enter Contact Number"
                    />
                  </div>
                </div>


                <div className="mr-5">
                  <label className="text-sm text-[#02264a] font-semibold">
                    Company Website{" "}
                  </label>
                  <div
                    className={`${error.companyWebsite
                      ? "bg-red-100 border-red-700 mb-0"
                      : " bg-transparent border-[1px] border-[#dcdcdc] mb-1"
                      } relative  p-2 w-full  rounded-md mt-1 border-[1px]   active:bg-transparent`}
                  >
                    <FaLink className="h-4 w-4 absolute left-3 top-3 text-[#02264a]" />
                    <input
                      className="bg-transparent ml-6 pl-5 focus:outline-none  pr-5 w-[90%] placeholder-[#767676] text-[#02264a]"
                      type="text"
                      name="companyWebsite"
                      id="companyWebsite"
                      autoComplete="new-password"
                      value={values.companyWebsite}
                      onChange={handleChange}
                      placeholder="Enter Company Website"
                    />
                  </div>
                  <div className="mb-3">
                    <span className="px-1 text-[#02264a]">
                      {" "}
                      eg. www.mywebsite.com
                    </span>
                  </div>
                </div>
                <div className="mr-5">
                  <label className="text-sm text-[#02264a] font-semibold">
                    Company GST/VAT Number{" "}
                  </label>
                  <div className={`${error.companyGST ? "bg-red-100 border-red-700 mb-0" : " bg-transparent border-[1px] border-[#dcdcdc] my-3"} relative  p-2 w-full  rounded-md mt-1 border-[1px]   active:bg-transparent`} >
                    <FaMobileAlt className="h-4 w-4 absolute left-3 top-3 text-[#02264a]" />
                    <input
                      className="bg-transparent ml-6 pl-5 focus:outline-none  pr-5 w-[90%] placeholder-[#767676] text-[#02264a]"
                      type="text"
                      name="companyGST"
                      id="companyGST"
                      autoComplete="new-password"
                      value={values.companyGST}
                      onChange={handleChange}

                      placeholder="Enter Company GST/VAT Number"
                    />
                     {/* {error.zipCode && (
                      <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                    )} */}
                  </div>
                  {/* {error.emailnmobi && <p className='my-2 px-2 text-red-600 text-xs'>{error.emailnmobi}</p>} */}
                </div>
                <div className="mr-5">
                  <label className="text-sm text-[#02264a] font-semibold">
                    Upload GST Document
                  </label>
                  <div className="flex flex-row  relative  p-1 w-full  rounded-md mt-1 bg-transparent border-[1px] border-[#dcdcdc] my-3   active:bg-transparent">
                    <input
                      type="file"
                      className="bg-transparent focus:outline-none  pr-5 w-[90%] placeholder-[#767676] text-[#02264a] block  text-sm
                          file:mr-4 file:py-2 file:px-4
                          file:rounded-full file:border-0
                          file:text-sm file:font-semibold
                          file:bg-violet-50 file:text-theme-color-yellow
                          hover:file:bg-violet-100"
                      name="CategoryImg"
                      id="CategoryImg"
                      onChange={handleFileChange}
                    />
                  </div>
                </div>
                <div className="mr-5">
                  <label className="text-sm text-[#02264a] font-semibold">
                    Address Line 1 <span className="text-red-700 "> * </span>{" "}
                  </label>
                  <div
                    className={`${error.address1
                      ? "bg-red-100 border-red-700 mb-0"
                      : " bg-transparent border-[1px] border-[#dcdcdc] my-3"
                      } relative  p-2 w-full  rounded-md mt-1 border-[1px]   active:bg-transparent`}
                  >
                    <FaMapMarkerAlt className="h-4 w-4 absolute left-3 top-3 text-[#02264a]" />
                    <input
                      className="bg-transparent ml-6 pl-5 focus:outline-none  pr-5 w-[90%] text-[#02264a] placeholder-[#767676]"
                      type="text"
                      name="address1"
                      id="address1"
                      autoComplete="new-password"
                      value={values.address1}
                      onChange={handleChange}
                      onKeyUp={handleChange}
                      placeholder="Enter Address Line 1"
                    />
                    {error.address1 && (
                      <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                    )}
                  </div>
                  {error.address1 && (
                    <p className="my-2 px-2 text-red-600 text-xs">
                      {error.address1}
                    </p>
                  )}
                </div>
                <div className="mr-5">
                  <label className="text-sm text-[#02264a] font-semibold">
                    Address Line 2 <span className="text-red-700 "> * </span>{" "}
                  </label>
                  <div
                    className={`${error.address2
                      ? "bg-red-100 border-red-700 mb-0"
                      : " bg-transparent border-[1px] border-[#dcdcdc] my-3"
                      } relative  p-2 w-full  rounded-md mt-1 border-[1px]   active:bg-transparent`}
                  >
                    <FaMapMarkerAlt className="h-4 w-4 absolute left-3 top-3 text-[#02264a]" />
                    <input
                      className="bg-transparent ml-6 pl-5 focus:outline-none  pr-5 w-[90%] placeholder-[#767676] text-[#02264a]"
                      type="text"
                      name="address2"
                      id="address2"
                      autoComplete="new-password"
                      value={values.address2}
                      onChange={handleChange}
                      onKeyUp={handleChange}
                      placeholder="Enter Address Line 2"
                    />
                    {error.address2 && (
                      <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                    )}
                  </div>
                  {error.address2 && (
                    <p className="my-2 px-2 text-red-600 text-xs">
                      {error.address2}
                    </p>
                  )}
                </div>

                {(users.length > 0 && users[0]?.IsIndian === 0) ? <div>
                  <label className="block w-full">
                    <span className="block text-sm font-medium text-[#333333]">Country</span>
                  </label>
                  <Select onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault();}}} options={countryData} placeholder="Select Country" onChange={handleGetState} />
                </div> : null}


                <div className="mr-5 my-2">
                  <label className="text-sm text-[#02264a] font-semibold">
                    States <span className="text-red-700 "> * </span>{" "}
                  </label>
                  <Select onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault();}}} className=" my-1" options={stateData} placeholder="Select State" onChange={handleGetCities} />
                </div>
                <div className="mr-5 my-2">
                  <label className="text-sm text-[#02264a] font-semibold">
                    City <span className="text-red-700 "> * </span>{" "}
                  </label>
                  <Select onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault();}}} className=" my-1" options={cityData} placeholder="Select City" onChange={handleSetCityId} />
                </div>

                {/* <div>
                  <div className="mr-5">
                    <div>
                      <label className="block text-sm font-medium text-gray-700">Country</label>
                      <Select onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault();}}} options={countryData.map((country) => ({ value: country.id, label: country.name, countrys: 1 }))}
                        value={selectedCountry}
                        onChange={handleCountryChange}
                        placeholder="Select Country"
                        className="my-1"
                      />
                    </div>

                    {selectedCountry && (
                      <div>
                        <label className="block text-sm font-medium text-gray-700">State</label>
                        <Select onKeyDown={(e) => {if (e.key === "Enter") {e.preventDefault();}}} options={getStates()} value={selectedState} onChange={handleCountryChange} placeholder="Select State" className="my-1" />
                      </div>
                    )}

                    {selectedState && (
                      <div>
                        <label className="block text-sm font-medium text-gray-700">Country</label>
                        <Select
                          options={getCities()}
                          value={selectedCity}
                          onChange={handleCountryChange}
                          placeholder="Select City"
                          className="my-1"
                        />
                      </div>
                    )}
                  </div>
                </div> */}
                <div className="mr-5 my-2">
                  <label className="text-sm text-[#02264a] font-semibold">
                    Zipcode / Pincode <span className="text-red-700 "> * </span>{" "}
                  </label>
                  <div
                    className={`${error.zipCode
                      ? "bg-red-100 border-red-700 mb-0"
                      : " bg-transparent border-[1px] border-[#dcdcdc] my-3"
                      } relative  p-2 w-full  rounded-md mt-1 border-[1px]   active:bg-transparent`}
                  >
                    <TbNumbers className="h-4 w-4 absolute left-3 top-3 text-[#02264a]" />
                    <input
                      className="bg-transparent ml-6 pl-5 focus:outline-none  pr-5 w-[90%] placeholder-[#767676] text-[#02264a]"
                      type="text"
                      name="zipCode"
                      id="zipCode"
                      autoComplete="new-password"
                      value={values.zipCode}
                      onChange={handleChange}
                      onKeyUp={handleChange}
                      onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                      placeholder="Enter Zipcode/Pincode"
                    />
                    {error.zipCode && (
                      <MdErrorOutline className="h-4 w-4 absolute right-3 top-3 text-red-600 text-xs" />
                    )}
                  </div>
                  {error.zipCode && (
                    <p className="my-2 px-2 text-red-600 text-xs">
                      {error.zipCode}
                    </p>
                  )}
                </div>
              </div>
              <div className=" flex flex-row justify-end pr-5">

                <button className="relative group w-[180px] h-14 rounded-full flex flex-row items-center bg-[#0bb29f] hover:bg-[#0bb29f] px-3">
                  {isLoading === true ? (
                    <span className="flex flex-row  text-md font-semibold text-white">
                      <AiOutlineLoading3Quarters className="animate-spin h-5 w-5 mr-3" />
                      Processing{" "}
                    </span>
                  ) : (
                    <span className="relative text-md text-center  text-white font-semibold">
                      Submit & Next
                    </span>
                  )}
                  <div className="flex items-center h-12 w-12 rounded-3xl bg-[#0bb29f] absolute right-0 z-20">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6 stroke-white translate-x-3 transition duration-300 group-hover:translate-x-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="2"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
                    </svg>
                  </div>
                </button>
              </div>
            </div>
          </form>
        </div>
        <ToastContainer />
      </div>
    </div>
  )
}

export default PersonalDetails